import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Session } from '../../services/session.service';

import { Router } from '@angular/router';
import {
  BaseComponent,
  ConfigurationSetting,
  MyClaim,
  TabGroupComponent,
  UserActionService,
} from 'src/app/shared';
import { ClaimInfo, ManagerResult } from 'src/app/shared/models/search-result';
import {
  ClaimantService,
  DisplayService,
  LogService,
  UserRoleService,
} from '../..';
import { NotificationItem, scrollToElement } from '../../../shared';
import { ActivityRequest } from '../../../shared/models/activity';
import { UserActions } from '../../../shared/models/user';
import { AccommodationJobFunction } from '../../models/accommodation';
import { AccommodationsService } from '../../services/accommodations-service';
import { ActivityService } from '../../services/activity.service';
import { ConfigurationService } from '../../services/configuration.service';
import { srSpeak } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationService } from '../../services/translation.service';
import { TranslationPipe } from '../../pipes/translation.pipe';
import {
  SummaryDashboardFilterValue,
} from '../controls/filter-by-manager.component';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-manager-dashboard',
    providers: [TranslationPipe],
    template: `
    @if (!userRole.auditor) {
      <app-section>
        <app-claim-breadcrumb class="tw-w-[80%]"></app-claim-breadcrumb>
        <div class="tw-w-[20%] tw-right">
          @if (countLoaded) {
            <button
              mat-icon-button
              alt="New Notifications"
              class="nopadding"
              role="button"
              [attr.aria-label]="'View new notification/s' | translation : translationRequest"
              tabindex="0"
              (click)="setNotificationFocus('Notifications', notificationCount)"
              >
              <mat-icon
                [matBadge]="notificationCount"
                matBadgeColor="accent"
                aria-hidden="false"
                >{{ 'notifications_none' }}</mat-icon
                >
              </button>
            }
          </div>
          <app-filter-by-manager
            class="tw-w-full"
            [translationRequest]="translationRequest"
            [initialSupervisor]="filterInitialSupervisor"
            [initialIncludeIndirect]="filterInitialIncludeIndirect"
            (supervisorSelected)="onSupervisorSelected($event)"
            (filterChange)="onFilterChange($event)"
          ></app-filter-by-manager>
          @if (this.welcomeMessageInfo && this.welcomeMessageInfo.length > 0) {
            <div
              class="tw-w-full"
              >
              <app-welcome [welcomeMessageInfo]="welcomeMessageInfo" [translationRequest]="translationRequest" />
            </div>
          }
          <app-panel
            class="tw-w-full"
            [showTitle]="true"
            [title]="headerLabel"
            [headerLevel]="1"
            [labelTemplate]="labelTemplate"
            [sentenceCase]="false"
            [canExpand]="false"
            >
            <ng-template #labelTemplate>
              <div
                class="tw-grow tw-items-center tw-justify-between tw-flex tw-flex-wrap tw-relative"
                >
                @if (employeeId) {
                  <div></div>
                }
                <div class="tw-w-[10%] ">
                  @if (!employeeId && !session.isDelegating()) {
                    <a
                      tabindex="0"
                      (keydown.enter)="redirectToMgrOwnEmpDashboard()"
                      class="app-pl2 app-header-link"
                      (click)="redirectToMgrOwnEmpDashboard()"
                      >{{ 'My claims' | translation : translationRequest }}</a
                      >
                    }
                  </div>
                  <div
                    class="tw-hidden md:tw-block app-pr2 tw-text-[14px] app-color-slate tw-font-bold tw-absolute tw-right-0"
                    >
                    {{ employeeLabel | aliasTransform:'titlecase' }}
                  </div>
                  <div
                    class="md:tw-hidden tw-block tw-w-[60%] app-pr2 app-pt3 tw-text-[14px] app-color-slate tw-font-bold tw-absolute tw-right-0"
                    >
                    {{ employeeLabel | aliasTransform:'titlecase' }}
                  </div>
                </div>
              </ng-template>
              <div class="tw-pt-4"></div>
              <app-loading-panel
                [state]="loaded ? 'Loaded' : 'Loading'"
                class="tw-h-full"
                loadingStyle="Image"
                loadingImageSrc="/assets/images/loader/manager-view-ghost.svg"
                >
                <ng-template #content>
                  <div class="tw-min-h-[800px]">
                    <app-manager-reminders
                      [managerActivities]="managerActivities"
                      [commCenterMsgCount]="unreadConversationMessagesCount"
                      [accommodationsCount]="accommodationsCount"
                      [translationRequest]="translationRequest"
                      (focusTab)="handleFocus($event)"
                      (filterApplied)="handleApplyFilter()"
                      class="tw-w-full"
                    ></app-manager-reminders>
                    <app-activity
                      id="mgrActivityPnl"
                      [claimInfo$]="claimInfo$"
                      [isHomePage]="true"
                      [mgrAction]="mgrAction"
                      [activities]="managerActivities"
                      [isFilterApplied]="isFilterApplied"
                      (clearFilter)="handleClearFilter()"
                      [focusTab]="focusTab"
                      [showTitle]="false"
                      [flat]="true"
                      [accommodationsData]="accommodationsJobfunctions"
                      [translationRequest]="translationRequest"
                    ></app-activity>
                  </div>
                </ng-template>
              </app-loading-panel>
            </app-panel>
            <div class="tw-w-full md:tw-w-[60%] comfloat-left">
              <div class="tw-flex tw-flex-wrap">
                <app-comm-center2-card
                  [translationRequest]="translationRequest" />
                </div>
              </div>
              @if (hasLearningCenter) {
                <div
                  class="tw-w-full md:tw-w-[40%] comfloat-right"
                  >
                  <div class="tw-flex tw-flex-wrap">
                    <div class="tw-w-full">
                      <app-visit-learning-center
                        class="tw-w-full"
                        [originator]="'managerDashboard'"
                        [translationRequest]="translationRequest"
                      ></app-visit-learning-center>
                    </div>
                  </div>
                </div>
              }
            </app-section>
          }
    `,
    styles: [
        `
      .nopadding {
        padding-left: 0px !important;
        width: 50px !important;
      }
      .tw-right {
        text-align: right;
      }
    `,
    ],
    standalone: false
})
export class ManagerDashboardComponent extends BaseComponent implements OnInit {
  @ViewChild(TabGroupComponent) tabGroup: TabGroupComponent;
  userActions = UserActions;
  claimInfo$ = new BehaviorSubject<ClaimInfo>(null);
  headerLabel: string = 'Manager view';
  welcomeMessageInfo: any;
  summary: any;
  employeeId: string;
  employeeLabel: Aliases;
  managerActivities: any;
  loaded: boolean = false;
  unreadConversationMessagesCount: number = 0;
  accommodationsCount: number = 0;
  maxBadgeCount = 99;
  hasLearningCenter: boolean = false;
  initialNotifications: NotificationItem[] = [];
  countLoaded: boolean = true;
  notificationCount: number = 0;
  activityRequest: ActivityRequest;
  isFilterApplied = false;
  mgrAction: UserActions | null;
  includeIndirectsInSession: string;
  filteredManagerInSession: any;
  claims: MyClaim[];
  filterInitialSupervisor: ManagerResult | null = null;
  filterInitialIncludeIndirect: boolean = false;
  currentFilter: SummaryDashboardFilterValue = {
    supervisor: null,
    includeIndirect: false,
  };
  @Output()
  focusTab = new EventEmitter<string>();

  @Output()
  valueChanged = new EventEmitter<boolean>();
  ClientLevelConfig: ConfigurationSetting;

  accommodationsJobfunctions: AccommodationJobFunction[] = [];

  hasSummary = true;

  @Output() reloadCommCenter = new EventEmitter<{
    supervisor: ManagerResult | null;
    includeIndirect: boolean;
  }>();
  
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  constructor(
    public configurationService: ConfigurationService,
    public session: Session,
    private activityService: ActivityService,
    public config: ConfigurationService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private userAction: UserActionService,
    public userRole: UserRoleService,
    public accommodationsService: AccommodationsService,
    private display: DisplayService,
    public claimantService: ClaimantService,
    private logService: LogService,
    private translationService: TranslationService,
    private translationPipe : TranslationPipe
  ) {
    super();
    this.subs.sink = this.activityService.notificationCount.subscribe(
      (count: number) => {
        this.notificationCount = count > this.maxBadgeCount ? 99 : count;
        this.countLoaded = true;
        this.cd.detectChanges();
      }
    );
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  async ngOnInit() {
    this.loadTranslations();
    this.mgrAction = UserActions.ViewOwnMgrDb;
    sessionStorage.setItem('highlightSideNav', 'false');
    if (!this.checkSessionStorage()) {
      this.setOwnLabel();
    }

    !this.session.user ? await this.session.loadUser() : null;
    await this.userAction.setAction(this.mgrAction);
    this.ClientLevelConfig =
      await this.configurationService.getAdditionalUserInformation();

    this.hasLearningCenter = true; // is not feature driven
    this.welcomeMessageInfo = await this.session.GetWelcomeMessage();
    if (!this.userRole.auditor) {
      this.currentFilter = {
        supervisor: this.filterInitialSupervisor,
        includeIndirect: this.filterInitialIncludeIndirect,
      };
      await this.fetchActivities(
        this.currentFilter.includeIndirect,
        this.currentFilter.supervisor?.empUnum ?? this.session.user.empUnum,
        this.filteredManagerInSession
          ? UserActions.FilterByManager
          : this.mgrAction
      );

      this.initialNotifications = this.managerActivities.notifications;
      this.subs.sink = this.activityService.focusNotification.subscribe(
        (x: string) => {
          this.handleFocus(x);
        }
      );

    }

    // this.claims = await (<any>this.claimService.getClaims());
  }

  async onFilterChange(value: SummaryDashboardFilterValue) {
    this.currentFilter = {
      supervisor: value.supervisor ?? null,
      includeIndirect: value.includeIndirect ?? false,
    };

    this.FeatureLogging(
      'InculdeIndirectReports',
      'Inculde Indirect Reports',
      'Manager View'
    )
    sessionStorage.setItem(
      this.session.user.sessionId + 'includeIndirects',
      value.includeIndirect.toString()
    );

    if(value.supervisor != undefined && value.supervisor.empUnum != undefined)
    {
       this.reloadCommCenter.emit({
        supervisor: value.supervisor,
        includeIndirect: value.includeIndirect,
      });
         await this.fetchActivities(
        value.includeIndirect,
        value.supervisor.empUnum ,
        UserActions.FilterByManager
      );
    }
    else
    {
      this.reloadCommCenter.emit({
        supervisor: null,
        includeIndirect: value.includeIndirect,
      });
      await this.fetchActivities(
        value.includeIndirect,
        this.session.user.empUnum,
        UserActions.ViewOwnMgrDb
      );
    }

  }

  async onSupervisorSelected(supervisor: ManagerResult | null) {
    this.FeatureLogging(
      'FilterByManager',
      supervisor ? '' : ' - Removed manager',
      'Filter By Manager'
    );
    if (supervisor && supervisor.empUnum != null) {
      this.reloadCommCenter.emit({
        supervisor,
        includeIndirect: this.currentFilter.includeIndirect,
      });
      sessionStorage.setItem(
        this.session.user.sessionId + 'filteredManager',
        JSON.stringify(supervisor)
      );
      this.headerLabel = `${supervisor.name}  - manager view`;
      this.employeeLabel = {
        value: this.claimantService.GetEmployeeLabel(
          null,
          null,
          supervisor.name,
          supervisor.employeeId
        ),
        key: 'employeeLabel',
        isOverride: false,
      } as Aliases;
      this.employeeId = supervisor.employeeId;
      this.userAction.setBustCache(true);
      await this.fetchActivities(
        this.currentFilter.includeIndirect,
        supervisor.empUnum,
        UserActions.FilterByManager
      );
      srSpeak('Results filtered by ' + supervisor.name, 'polite');
    } else if (supervisor === null) {
      this.removeFromSessionStorage(
        this.session.user.sessionId + 'filteredManager'
      );
      this.reloadCommCenter.emit({
        supervisor: null,
        includeIndirect: this.currentFilter.includeIndirect,
      });
      this.userAction.setBustCache(true);
      this.setOwnLabel();

      await this.fetchActivities(
        this.currentFilter.includeIndirect,
        this.session.user.empUnum,
        UserActions.ViewOwnMgrDb
      );
      srSpeak('Your own manager dashboard loaded', 'polite');
    }
  }

  unreadMessagesWithMax = (): number => {
    return this.unreadConversationMessagesCount > 99
      ? this.maxBadgeCount
      : this.unreadConversationMessagesCount;
  };

  async fetchActivities(
    inclIndirects: boolean,
    mgrEmpUnum: string,
    userAction: UserActions
  ) {
    this.loaded = false;
    const path = '/api/manager/get-activities';
    this.activityRequest = {
      includeIndirects: inclIndirects,
      userActions: userAction,
      claimKeys: [],
      userOwns: false,
      empUnum: mgrEmpUnum,
      delegateeEmpUnum: this.session.isDelegating()
        ? this.session.user.delegateeContext?.empUnum
        : null,
    };
    try {
      const [activities] = await Promise.all([
        this.activityService.getActivities(path, this.activityRequest),
        this.fetchAccommodations(inclIndirects, mgrEmpUnum, userAction),
      ]);

      this.managerActivities = activities;
    } catch (error) {
      console.error('Error getting activities:', error);
    } finally {
      this.notificationCount = this.managerActivities.notifications.length;
      this.loaded = true;
      this.userAction.setBustCache(false); //revert after the getActivities call which might be set after dismissing notifications from subpage
    }
  }

  async fetchAccommodations(
    inclIndirects: boolean,
    mgrEmpUnum: string,
    userAction: UserActions
  ) {
    if (!this.display.accommodations) {
      this.accommodationsJobfunctions = [];
      this.accommodationsCount = 0;
      return Promise.resolve();
    }

    this.accommodationsJobfunctions =
      await this.accommodationsService.getManagerAccommodations(
        inclIndirects,
        userAction,
        false,
        mgrEmpUnum
      );

    this.accommodationsCount = this.accommodationsJobfunctions.filter(
      (x) =>
        x.status === 'Open' &&
        x.requestSubStatusTypeId === '24' &&
        (x.decisionId === '1' || x.jobFunctionStatusId === '1')
    ).length;
  }

  handleFocus(tabName: string) {
    this.focusTab.emit(tabName);
  }

  handleApplyFilter() {
    this.isFilterApplied = true;
    this.loaded = true;
  }

  handleClearFilter() {
    this.isFilterApplied = false;
    this.loaded = true;
  }

  unreadMessageCountCallback = (evt: any) => {
    const cnt = evt as number;
    this.unreadConversationMessagesCount = cnt;
  };

  setNotificationFocus(type: any, notificationCount: number) {
    this.FeatureLogging(
      'Notifications',
      notificationCount.toString(),
      'Notifications - count'
    );
    const notification = document.getElementById('activitypnl');
    if (notification != null) {
      this.activityService.setFocusToNotification(type);
      scrollToElement('activitypnl', false, 65);
    }
  }

  setCommCenterFocus() {
    const commcenter = document.getElementById('commCenterPnl');
    if (commcenter != null) {
      commcenter.scrollIntoView();
    }
  }

  redirectToMgrOwnEmpDashboard() {
    this.FeatureLogging('MyClaims', 'My Claims', 'Manager View');
    this.userAction.setAction(UserActions.ViewOwnEmpDb);
    this.router.navigate(['dashboard'], {});
  }

  checkSessionStorage(): boolean {
    let filteredManagerInSession = false;
    this.includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects'
    );
    this.filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager'
    );
    if (this.includeIndirectsInSession) {
      this.filterInitialIncludeIndirect =
        this.includeIndirectsInSession === 'true';
    } else {
      this.filterInitialIncludeIndirect = false;
    }
    if (this.filteredManagerInSession) {
      this.filterInitialSupervisor = JSON.parse(
        this.filteredManagerInSession
      );
      this.setFilteredManagerLabel();
      filteredManagerInSession = true;
    }
    return filteredManagerInSession;
  }

  async removeFromSessionStorage(itemToRemove: any) {
    sessionStorage.removeItem(itemToRemove);
  }

  setOwnLabel() {
    this.employeeLabel = {
      value: this.claimantService.GetEmployeeLabel(
        this.session.user?.firstName,
        this.session.user?.lastName,
        null,
        this.session.user?.employeeId
      ),
      key: 'employeeLabel',
      isOverride: false,
    } as Aliases;
    this.employeeId = null;
    this.headerLabel = 'Manager view';
  }

  setFilteredManagerLabel() {
    if (!this.filterInitialSupervisor) {
      return;
    }
    this.employeeLabel = {  
      value: this.claimantService.GetEmployeeLabel(
        null,
        null,
        this.filterInitialSupervisor.name,
        this.filterInitialSupervisor.employeeId
      ),
      key: 'employeeLabel',
      isOverride: false,
    } as Aliases;

    this.headerLabel =
      this.filterInitialSupervisor.name + ' - manager view';
  }
}
